// extracted by mini-css-extract-plugin
export var deleteModal = "_id-0";